import { observer } from 'mobx-react-lite';
import { AuthorizationView } from '../authorizationView/authorization.view';

export const AuthorizationController: React.FC = observer(
  (): JSX.Element => <AuthorizationView />,
);
